module.exports = __webpack_public_path__ + "static/media/mode-38.00d7a12d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-38.svg
// module id = 1011
// module chunks = 2